import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { categoryColumns, productColumns, userColumns, userRows } from "../../datatablesource";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCategories, getProducts, getUsers } from "../../actions/fetchData";
import { CircularProgress } from "@mui/material";
import { deleteCategory } from "../../actions/deleteData";

const Datatable = ({type}) => {
  const location = useLocation()
  const dispatch = useDispatch()
  const columns = categoryColumns
  const [data, setData] = useState([]);
  const {categories, isLoading, countC} = useSelector((state)=>state.category)
  

  useEffect(()=>{
    !categories.length && dispatch(getCategories())
  },[location])
  useEffect(()=>{
    categories?.forEach((p)=>{
      p["id"]=p["_id"]
    })
    setData(categories)
  },[isLoading])
  
  const handleDelete = (id) => {
    setData(data.filter((item) => item.id !== id));
    dispatch(deleteCategory(id))
  };


  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link to={params.row.id} style={{ textDecoration: "none" }}>
              <div className="viewButton" style={{backgroundsColor:'#141D37', color:'#141D37'}}>View</div>
            </Link>
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
  <>
      <div className="datatable">
      <div className="datatableTitle">
        {`${type}`}
        <Link to={`/categories/new`} style={{backgroundsColor:'#141D37', color:'#141D37'}} className="link">
          Add New
        </Link>
      </div>
    { isLoading? <CircularProgress/> :(
      <DataGrid
        className="datagrid"
        rows={data}
        columns={columns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />)}
    </div>
  </>
  );
};

export default Datatable;
